<div *ngIf="isAuthenticating$ | async" class="verify_spinner">
	<ahp-spinner></ahp-spinner>
</div>
<gap-card>
	<gap-card-title>{{ 'verify.header' | locale }}</gap-card-title>
	<gap-card-content class="verify--instructions" [innerHTML]="instructionsLocale"></gap-card-content>
	<gap-card-content>
		<ahp-dynamic-form
			[controls]="verifyFormControls"
			[formSubmitted]="verifyCodeSubmitted"
			(formValidityChange)="verifyFormChanged($event)"
			#verifyForm
		></ahp-dynamic-form>
	</gap-card-content>
	<gap-card-actions class="verify--actions button--no-margin">
		<gap-button
			data-cy="verify__button--submit"
			gap-color="secondary"
			gap-type="raised"
			ahpAnalyticsClick='button|{"button_section":"verify","button_action":"submit"}'
			[disabled]="isAuthenticating$ | async"
			(click)="onSubmit()"
		>
			<ng-container *ngIf="isAuthenticating$ | async; else normalText">
				{{ 'common.authenticating' | locale }}
			</ng-container>
			<ng-template #normalText>
				{{ 'verify.submit' | locale }}
			</ng-template>
		</gap-button>
		<gap-button
			data-cy="verify__button--backToLogin"
			gap-color="secondary"
			gap-type="outlined"
			ahpAnalyticsClick='button|{"button_section":"verify","button_action":"back to login"}'
			ahpRouteTo="login"
			[disabled]="isAuthenticating$ | async"
		>
			{{ 'verify.login' | locale }}
		</gap-button>

		<div class="resendbtn-container">
			<span class="resend-text">
				{{ 'verify.resendtext' | locale }}
			</span>
			<ng-container *ngIf="countdownToResend === 0; else waitTimer">
				<gap-button
					class="verify__button--resendCode"
					data-cy="verify__button--resendCode"
					gap-type="text"
					ahpAnalyticsClick='button|{"button_section":"verify","button_action":"resendcode"}'
					[disabled]="isAuthenticating$ | async"
					(click)="resendCode()"
				>
					{{ 'verify.resendbtn' | locale }}
				</gap-button>
			</ng-container>
			<ng-template #waitTimer>
				<div class="resend-countdown__wrapper" data-cy="resend-countdown__wrapper">
					<gap-iconography
						data-cy="resend-countdown__icon"
						gap-icon="timer-outline"
						gap-color="secondary"
					></gap-iconography>
					{{ 'common.youcanrequestanewcodein' | locale }}
					<span
						role="timer"
						class="resend-countdown__seconds"
						[attr.aria-label]="'common.youcanrequestanewcodein' | locale"
						aria-live="polite"
						>{{ countdownDisplay }}</span
					>
				</div>
			</ng-template>
		</div>
	</gap-card-actions>
</gap-card>
